import React from "react";
import { Container, Box, Typography, Grid, Fade } from "@mui/material";
import ImageCarousel from "../components/Gallery/ImageCarousel";
import ChatInterface from "../components/Chat/ChatInterface";

const HomePage = () => {
  return (
    <Box sx={{ minHeight: "calc(100vh - 64px)" }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Hero Section */}
        <Fade in timeout={800}>
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 800,
                fontSize: { xs: "2.5rem", md: "3.5rem" },
              }}
            >
              Meet Lucky
            </Typography>
            <Typography
              variant="h5"
              color="text.secondary"
              sx={{ maxWidth: 600, mx: "auto", mb: 2 }}
            >
                All about Lucky and his adventures
            </Typography>
          </Box>
        </Fade>

        {/* Main Content Grid */}
        <Grid container spacing={4}>
          {/* Gallery Section */}
          <Grid item xs={12} md={6}>
            <Fade in timeout={1000}>
              <Box>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{ mb: 3, fontWeight: 600 }}
                >
                  Lucky's Gallery
                </Typography>
                <ImageCarousel />
              </Box>
            </Fade>
          </Grid>

          {/* Chat Section */}
          <Grid item xs={12} md={6}>
            <Fade in timeout={1200}>
              <Box>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{ mb: 3, fontWeight: 600 }}
                >
                  Ask Lucky Anything
                </Typography>
                <ChatInterface />
              </Box>
            </Fade>
          </Grid>
        </Grid>

        {/* Info Section */}
        <Fade in timeout={1400}>
          <Box
            sx={{
              mt: 6,
              p: 4,
              borderRadius: 3,
              background: "linear-gradient(135deg, #667eea15 0%, #764ba215 100%)",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" gutterBottom fontWeight={600}>
              Coming Soon
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Sign in with Google to save your conversations and get personalized
              responses from Lucky's AI assistant!
            </Typography>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default HomePage;
